import { IBaseMapProvider } from "../types";
import { APP_URL } from "@/common/http";

export const GOOGLE_MAPS_API_KEY = 'AIzaSyCtq5nlS9P7FbjtCIe08T8ezk5t43Q8XXQ';

export const BASEMAP: IBaseMapProvider[] = [
  { Name: 'GISTDA',
    Maps: [
      { Type:'Thaichote',
        Id: 'gistda.thaichote',
        IsImage: true,
        Url: 'http://go-tiles1.gistda.or.th/mapproxy/tms/1.0.0/thaichote/EPSG3857/{z}/{x}/{y}.png',
        Resolutions: [
          /*156543.03392804097,*/78271.516964,39135.758482,19567.879241,9783.9396205,4891.96981025,2445.98490513,1222.99245256,
          611.496226281,305.748113141,152.87405657,76.4370282852,38.2185141426,19.1092570713,9.55462853565,
          4.77731426782,2.38865713391,1.19432856696,0.597164283478,0.298582141739,0.1492910709
        ],
        //Extent: [11441534.709664, 1691965.8469448, 11814547.407644, 1213164.3018332],
        Origin: [-20037508.342789244, -20037508.342789244],
        Attributions: [
          'GISTDA © 2561&nbsp;<a href="https://www.gistda.or.th/">ThaiChote</a>'
        ]
      }/*,{ Type:'Planet',
        Id: 'gistda.planet',
        IsImage: true,
        //WMTS not working
        //wmtsMatrixSet: 'GoogleMapsCompatible15',
        //featureType: 'thailand_2018q4_mosaic',
        //Url: 'https://api.planet.com/basemaps/v1/mosaics/wmts?api_key=c6ccb43c4e1c45a6b7566b52f4e468b8'
        //use XYZ layer, instead
        Url: 'https://tiles.planet.com/basemaps/v1/planet-tiles/thailand_2018q4_mosaic/gmap/{z}/{x}/{y}.png?api_key=c6ccb43c4e1c45a6b7566b52f4e468b8'
      }*/
    ]
  },
  { Name: 'Google',
    Key: GOOGLE_MAPS_API_KEY, // GISagroWeb
    Maps: [
      { Type: 'Road', 
        Id: 'google.road',
        Url: 'http://mt{0-3}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&key=' + GOOGLE_MAPS_API_KEY,
        StaticMapUrl: 'https://maps.googleapis.com/maps/api/staticmap?maptype=road',
        Legend: 'bm.google.street.jpg'
      },
      //{ Type: 'Terrain', 
      //  Id: 'google.terrain',
      //  Url: 'http://mt{0-3}.google.com/vt/lyrs=t&x={x}&y={y}&z={z}',
      //  Zoom: 8,
      //  Legend:'bm.google.topo.jpg'
      //},
      { Type: 'Terrain', //Terrain & Road
        Id: 'google.terrain',
        Url: 'http://mt{0-3}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}&key=' + GOOGLE_MAPS_API_KEY,
        StaticMapUrl: 'https://maps.googleapis.com/maps/api/staticmap?maptype=terrain',
        Zoom: 8,
        Legend:'bm.google.topo.jpg'
      },{
        Type: 'Satellite',
        Id: 'google.satellite',
        IsImage: true,
        Url: 'http://mt{0-3}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}&key=' + GOOGLE_MAPS_API_KEY,
        StaticMapUrl: 'https://maps.googleapis.com/maps/api/staticmap?maptype=satellite',
        Zoom: 14,
        Legend: 'bm.google.sat.jpg'
      },{
        Type: 'Hybrid', 
        Id: 'google.hybrid',
        IsImage: true,
        Url: 'http://mt{0-3}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}&key=' + GOOGLE_MAPS_API_KEY,
        StaticMapUrl: 'https://maps.googleapis.com/maps/api/staticmap?maptype=hybrid',
        Zoom: 14,
        Legend:'bm.google.hybrid.jpg'
      }
      //{ Type: 'RoadName', 
      //  Id: 'google.roadname',
      //  IsImage: true,
      //  Url: 'http://mt{0-3}.google.com/vt/lyrs=h&x={x}&y={y}&z={z}',
      //  Zoom: 14,
      //  Legend:'bm.google.hybrid.jpg'
      //},{ Type: 'RoadOnly', 
      //  Id: 'google.roadonly',
      //  IsImage: true,
      //  Url: 'http://mt{0-3}.google.com/vt/lyrs=r&x={x}&y={y}&z={z}',
      //  Zoom: 14,
      //  Legend:'bm.google.hybrid.jpg'
      //}
    ]
  },
  { Name: 'Bing',
    Key:'ApTJzdkyN1DdFKkRAE6QIDtzihNaf6IWJsT-nQ_2eMoO4PN__0Tzhl2-WgJtXFSp',
    Maps: [
      { Type:'Road', 
        Id: 'bing.road',
        Legend:'bm.bing.road.jpg'
      },
      /*{ Type:'RoadOnDemand', 
          Id: 'bing.roadondemand',
          Legend:'bm.bing.road.jpg'
      },*/
      { Type:'AerialWithLabels', 
        Id: 'bing.aerialwithlabels',
        IsImage: true,
        Zoom: 14,
        Legend:'bm.bing.hybrid.jpg'
      },{
        Type:'Aerial', 
        Id: 'bing.aerial',
        IsImage: true,
        Zoom: 14,
        Legend:'bm.bing.sat.jpg'
      }
    ]
  },
  { Name:  'OSM',
    Key:'a5dd6a2f1c934394bce6b0fb077203eb',
    Maps: [
      { Type:'Mapnik', 
        Id: 'osm.mapnik',
        Url:'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png', 
        Legend:'bm.osm.mapnik.jpg'
      },{
        Type:'Cycle', 
        Id: 'osm.cycle',
        Url:'https://{a-c}.tile.thunderforest.com/cycle/{z}/{x}/{y}.png',
        Legend:'bm.osm.cyclemap.jpg'
      },{
        Type:'Transport', 
        Id: 'osm.transport', 
        Url:'https://{a-c}.tile.thunderforest.com/transport/{z}/{x}/{y}.png',
        Legend:'bm.osm.cyclemap.jpg'
      },{
        Type:'Stamen Water', 
        Id: 'osm.stamen.water', 
        Url:'https://stamen-tiles-{a-c}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg',
        Legend:'bm.osm.cyclemap.jpg'
      }
    ]
  }
];

// basemap for internal test in case of no internet
export const BASEMAP_INTERNAL_WMS = {
  Name: 'INTERNAL',
  Maps: [
    { Type: "WMS",
      service: 'WMS',
      Id: 'internal.wms',
      IsImage: false,
      params: {
        'LAYERS': 'gis:mwa_district',
        'TILED': true
      }
    }
  ]
}

export const DEFAULT_BASEMAP = 'osm.mapnik'; // provider.maptype

export default BASEMAP;
